import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const ChartBar = ({

    data
}) => {

    const options = {
        xaxis: {
            categories: ["Asks","Bids"]
        },
        colors: [
            '#0445fb',
            '#d7dd03',
            '#2cd732',
            '#C70039'
        ],plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          dataLabels: {
            enabled: false
          },
        
    }

    const series = useMemo(() => {
        if (Array.isArray(data) && data.length) {
            return data.map(item => (
                {
                name: item.name.split('-')[1],
                data: [item.allAsks.toFixed(2), item.allBids.toFixed(2),]
            }))
        }

        return []
    }, [data])

    return <Chart
        options={options}
        series={series}
        type="bar"
        width="500"
    />


}

export default ChartBar